import { Icon, Flex, Text } from '@vibe/core';
import { dropdownValue } from '@gorilla/ui/src/components/dropdownValue';
import { Dropdown } from '@vibe/core';
import { BoardColumn } from '@gorilla/common/src/lib/monday-api/api';
import { Column as ColumnIcon } from '@vibe/icons';

const BOARD_COLUMNS_META = {
  people: {
    tooltip: 'People',
  },
  status: {
    tooltip: 'Status',
  },
  text: {
    tooltip: 'Text',
  },
  date: {
    tooltip: 'Date',
  },
  numbers: {
    tooltip: 'Numbers',
  },
  timeline: {
    tooltip: 'Timeline',
  },
  'timeline-numeric': {
    tooltip: 'Timeline + Numeric',
  },
  tags: {
    tooltip: 'Tags',
  },
  'connect-boards': {
    tooltip: 'Connect Boards',
  },
  mirror: {
    tooltip: 'Mirror',
  },
  rating: {
    tooltip: 'Rating',
  },
  dropdown: {
    tooltip: 'Dropdown',
  },
  'world-clock': {
    tooltip: 'World Clock',
  },
  checkbox: {
    tooltip: 'Checkbox',
  },
  link: {
    tooltip: 'Link',
  },
  'auto-number': {
    tooltip: 'Auto Number',
  },
  country: {
    tooltip: 'Country',
  },
  location: {
    tooltip: 'Location',
  },
  week: {
    tooltip: 'Week',
  },
  'progress-tracking': {
    tooltip: 'Progress Tracking',
  },
  'long-text': {
    tooltip: 'Long Text',
  },
  phone: {
    tooltip: 'Phone',
  },
  'item-id': {
    tooltip: 'Item ID',
  },
  formula: {
    tooltip: 'Formula',
  },
  'color-picker': {
    tooltip: 'Color Picker',
  },
  'last-updated': {
    tooltip: 'Last Updated',
  },
  'time-tracking': {
    tooltip: 'Time Tracking',
  },
  file: {
    tooltip: 'File',
  },
  email: {
    tooltip: 'Email',
  },
  hour: {
    tooltip: 'Hour',
  },
};

type ColumnPickerProps = {
  placeholder?: string;
  columns: BoardColumn[];
  value?: string;
  clearable?: boolean;
  isSmall?: boolean;
  hideIcons?: boolean;
  isDisabled?: boolean;

  onChange: (column?: BoardColumn) => void;
};

export function ColumnPicker({
  columns,
  value,
  clearable = false,
  onChange,
  placeholder = 'Choose column',
  isSmall,
  hideIcons,
  isDisabled,
}: ColumnPickerProps) {
  const options = columns.map((column) => {
    // @ts-ignore
    const columnMeta = BOARD_COLUMNS_META[column.type];
    const leftIcon = ColumnIcon;

    return {
      label: (
        <Flex gap={8}>
          {!hideIcons && <Icon icon={leftIcon} size={20} />}
          {column.title}
        </Flex>
      ),
      //leftIcon,
      //label: column.title,
      value: column.id,
    };
  });

  let selectedOption = options.find((option) => option.value === value) || null;

  return (
    <>
      <div
        style={{
          position: 'relative', // z-index fix for dropdowns
          width: '100%',
        }}
      >
        <Dropdown
          onOptionSelect={(ev: any) => {
            const fieldId = ev.value;
            const column = columns.find(({ id }) => id === fieldId);

            if (column && column.id !== '___inaccessible_field___') {
              onChange(column);
            }
          }}
          onClear={() => {
            onChange(undefined);
          }}
          disabled={isDisabled}
          value={dropdownValue(selectedOption)}
          options={options}
          placeholder={placeholder}
          //insideOverflowContainer
          clearable={clearable}
          searchable={false}
          size={isSmall ? 'small' : 'medium'}
          //className="custom_dropdown"
          //dropdownMenuWrapperClassName="dropdown_content_indexed"
        />
      </div>
    </>
  );
}
